export default "__VITE_ASSET__BMbV3GxQ__"